import React from 'react';
import { Router, Route, Switch } from 'react-router-dom'
import App from '../app.jsx';

import Layout from '../components/presentational/layout.jsx';
import FlowLayout from '../flow_layout';
import Login from '../components/login.jsx';
import MainSelection from '../components/main_selection.jsx';

import EquipmentValidationComplete from '../components/common/equipment_validation_complete.jsx';
import ValidateEquipment from '../components/common/validate_equipment.jsx';
import SiteSurvey from '../components/site_survey/site_survey.jsx';
import Confirmation from '../components/update/confirmation.jsx';
import SiteSurveyFormSelection from '../components/site_survey/form_selection.jsx'
import PrivateRoute from '../components/private_route.js'


function requireAuth (store) {
  return (nextState, transition, next) => {
    store.getState().auth.isLoggedIn.then(() => {
      next();
    }).catch((e) => {
      console.error(e);
      transition({pathname: '/', state: { nextPathname: nextState.location.pathname}});
      next();
    });
  }
}

export default (store) => {
  return (
    <App>
      <Switch>
        <Route path="/main">
          <Layout>
            <Switch>
              <PrivateRoute path="/main" component={MainSelection} />
            </Switch>
          </Layout>
        </Route>
        <Route path="/site_survey">
          <Layout>
            <FlowLayout>
              <Switch>
                <PrivateRoute component={ValidateEquipment} path="/site_survey/validate-equipment" />
                <Route component={EquipmentValidationComplete} path="/site_survey/equipment-validation-complete" />
                <Route component={SiteSurvey} path="/site_survey/data-collection" />
                <Route component={SiteSurveyFormSelection} path="/site_survey/form-selection" />
                {/* <Route component={Confirmation} path="/update/confirmation" /> */}
              </Switch>
            </FlowLayout>
          </Layout>
        </Route>
        <Route path="/update">
          <Layout>
            <FlowLayout>
              <Route component={Confirmation} path="/update/confirmation" />
            </FlowLayout>
          </Layout>
        </Route>
        <Route path="/" component={Login} />
      </Switch>
    </App>
  );
}
